import { render } from "./CustomersViewsDetail.vue?vue&type=template&id=bbe87bca&scoped=true"
import script from "./CustomersViewsDetail.vue?vue&type=script&lang=js"
export * from "./CustomersViewsDetail.vue?vue&type=script&lang=js"

import "./CustomersViewsDetail.vue?vue&type=style&index=0&id=bbe87bca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbe87bca"]])

export default __exports__